import React, { useEffect, useState } from "react";
import "./inspectionlist.css";
import "../../Dashboard/Sidebar";
import ReactPaginate from "react-paginate";
import Header from "../../layout/header";
import BottomMenu from "../../layout/bottomMenu";
import DashboardMenu from "../../layout/dashboardMenu";
import Loader from "../../../Loader/Loader";
import Moment from "moment";
import NotFoundData from "../../../Images/no-data-found.webp";
import "../../main_2.css";
const InspectionList = ({
  getInspectionListing,
  inspectionList = [],
  accountDetails,
  accountList = [],
  match,
  getFilter,
  accountFilterContent = [],
  getCityByStateId,
  geoCity = [],
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [filterInputList, setFilterInputList] = useState([{}]);
  const [filterView, setfilterView] = useState([{}]);
  const [requiredDataOnChange, setRequiredDataOnChange] = useState([
    { City: "" },
  ]);
  const [isGlobalSearch, setIsGlobalSearch] = useState(false);
  const [isFilterRemove, setIsRemoveFilter] = useState(false);
  const [pageNo, setPage] = useState(1);
  const [roleId, setRoleId] = useState("");
  const [checkForThreeMonth, setCheckForThreeMonth] = useState(4);

  useEffect(() => {
    let roleId = localStorage.getItem("role_id");
    setRoleId(roleId);
  }, []);

  const onPageChange = async (val) => {
    setIsLoading(true);
    setPage(val?.selected + 1);
    if (match?.params.lead_id !== undefined) {
      await accountDetails(
        val?.selected + 1,
        match?.params.lead_id,
        searchValue,
        filterInputList
      );
    } else if (match?.params?.stage_id !== undefined) {
      await accountDetails(val?.selected + 1, 0, searchValue, [
        { stage_id: match?.params?.stage_id },
      ]);
    } else {
      await accountDetails(val?.selected + 1, 0, searchValue, filterInputList);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    (async () => {
      const filter = JSON.parse(localStorage.getItem("account_filter"));
      if (filter !== null) {
        setFilterInputList(filter);
      }

      setIsLoading(true);
      if (match?.params.lead_id !== undefined) {
        await accountDetails(
          pageNo,
          match?.params.lead_id,
          searchValue,
          filterInputList
        );
      } else if (match?.params?.stage_id !== undefined) {
        await accountDetails(pageNo, 0, searchValue, [
          { stage: match?.params?.stage_id },
        ]);
      } else {
        await accountDetails(pageNo, 0, searchValue, filterInputList);
      }
      await getFilter();
      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await getInspectionListing(match?.params?.id);
      setIsLoading(false);
    };
  
    fetchData(); 
  
  }, [match?.params?.id]); 
  

  const [open, setOpen] = useState(false);

  const handleSearch = async () => {
    if (searchValue === "") {
      return false;
    }
    window.localStorage.search_account = searchValue;
    if (match?.params.lead_id !== undefined) {
      setIsLoading(true);
      await accountDetails(
        pageNo,
        match?.params.lead_id,
        searchValue,
        filterInputList,
        isGlobalSearch
      );
      setIsLoading(false);
    } else {
      setIsLoading(true);
      await accountDetails(
        pageNo,
        0,
        searchValue,
        filterInputList,
        isGlobalSearch
      );
      setIsLoading(false);
    }
  };

  const handleFilter = async (key, value, stringValue = "") => {
    if (key === "state") {
      await getCityByStateId(value);
    }
    const list = [...filterInputList];
    const view = [...filterView];
    list[0][key] = value;
    view[0][key] = value;
    if (stringValue !== "") {
      view[0][key] = stringValue;
      setfilterView(view);
    } else {
      setfilterView(view);
    }
    setFilterInputList(list);
  };

  useEffect(() => {
    if (geoCity && geoCity?.data !== undefined) {
      requiredDataOnChange[0]["City"] = geoCity?.data;
      setRequiredDataOnChange(requiredDataOnChange);
    }
  }, [geoCity, accountFilterContent]);

  const handleSubmitFilter = async () => {
    setOpen(false);
    setIsLoading(true);
    if (match?.params.lead_id !== undefined) {
      await accountDetails(
        pageNo,
        match?.params.lead_id,
        searchValue,
        filterInputList
      );
    } else {
      await accountDetails(pageNo, 0, searchValue, filterInputList);
    }
    setIsLoading(false);
  };

  const handleRemoveFilter = async (key) => {
    if (key !== "") {
      delete filterView[0][key];
      delete filterInputList[0][key];
      delete filterInputList[0][key + "_name"];
      setfilterView(filterView);
      setFilterInputList(filterInputList);
      setIsLoading(true);
      if (match?.params.lead_id !== undefined) {
        await accountDetails(
          pageNo,
          match?.params.lead_id,
          searchValue,
          filterInputList
        );
      } else {
        await accountDetails(pageNo, 0, searchValue, filterInputList);
      }
      setIsLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      if (isFilterRemove) {
        setfilterView([{}]);
        setFilterInputList([{}]);
        setIsLoading(true);
        if (match?.params.lead_id !== undefined) {
          await accountDetails(pageNo, match?.params.lead_id, searchValue);
        } else {
          await accountDetails(pageNo, 0, searchValue);
        }
        setIsLoading(false);
        setIsRemoveFilter(false);
      }
    })();
  }, [isFilterRemove]);

  const handleKeyDown = async (event) => {
    if (event.key === "Enter" && searchValue !== "") {
      event.preventDefault();
      if (match?.params.lead_id !== undefined) {
        setIsLoading(true);
        await accountDetails(
          pageNo,
          match?.params.lead_id,
          searchValue,
          filterInputList,
          isGlobalSearch
        );
        setIsLoading(false);
      } else {
        setIsLoading(true);
        await accountDetails(
          pageNo,
          0,
          searchValue,
          filterInputList,
          isGlobalSearch
        );
        setIsLoading(false);
      }
    }
  };

  const removeSearchFilter = async () => {
    delete window.localStorage.search_account;
    setIsLoading(true);
    if (match?.params.lead_id !== undefined) {
      await accountDetails(pageNo, match?.params.lead_id);
    } else if (match?.params?.stage_id !== undefined) {
      await accountDetails(pageNo, 0, "", [{ stage: match?.params?.stage_id }]);
    } else {
      await accountDetails(pageNo, 0);
    }
    await getFilter();
    setIsLoading(false);
  };


  useEffect(() => {
    if(inspectionList?.data && inspectionList?.data.length > 0){
      const createdAtDate = new Date(inspectionList?.data[inspectionList?.data.length-1]?.created_at);
      const currentDate = new Date();

      let months;
      months = (currentDate.getFullYear() - createdAtDate.getFullYear()) * 12;
      months -= createdAtDate.getMonth();
      months += currentDate.getMonth();
      setCheckForThreeMonth(months)
    }
  }, [inspectionList])


  return (
    <>
      <Loader isLoading={isLoading} />
      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header title={"Inspection List"} />
            <div className="container-fluid common-bg">
              <div className="container-fluid bootstrap snippets bg-white">
                <div className="row b-13">
                </div>
                <div className="d-sm-flex align-items-center justify-content-between mt-2 mb-2">
                </div>
                {/* Filter View */}
                {filterView[0] !== undefined &&
                  Object.keys(filterView[0])?.length > 0 && (
                    <div className="d-sm-flex align-items-center justify-content-between mb-4">
                      <div className="row pd-filter-div">
                        <div className="col-md-12 col-sm-12 d-flex">
                          <div className="applied-filter">
                            {Object.keys(filterView[0]).map((val, i) => {
                              return (
                                <>
                                  <span className="fd-1">
                                    <span
                                      style={{ textTransform: "capitalize" }}
                                    >
                                      {val.replaceAll("_", " ")}
                                    </span>
                                    {" - " + filterView[0][val]}
                                    <i
                                      className="bi bi-x-circle"
                                      onClick={(e) => {
                                        handleRemoveFilter(val);
                                      }}
                                    ></i>
                                  </span>
                                </>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                {/* Filter View End*/}
                <div className="row">
                  {/*CARD START*/}
                  {inspectionList &&
                    inspectionList?.data !== undefined &&
                    inspectionList?.data !== [] &&
                    inspectionList?.data.map((val, i) => {
                      return (
                        <>
                          <div className="col-md-4 col-sm-6">
                            <div className="card-big-shadow">
                              <div
                                className="card card-just-text"
                                data-background=""
                                data-color=""
                                data-radius="none"
                              >
                                <div className="content">
                                  {(val?.name) ? (
                                    <> 
                                      <h6 className="category mrg-b-12">
                                          <div className={`header-ui-item-opp bg-success text-white`}>
                                              {'Assigned'}
                                          </div>
                                      </h6>
                                    </>
                                  ):(
                                    <>
                                      <h6 className="category mrg-b-12">
                                          <div className={`header-ui-item-opp bg-primary text-white`}>
                                              {'Not Assigned'}
                                          </div>
                                      </h6>
                                    </>
                                  )}
                                  
                                  <h6 className="category mrg-b-12">
                                    <div className="row">
                                      <div
                                        className="col-10"
                                        style={{
                                          color: "#000",
                                          fontSize: "20px",
                                          textAlign: "left",
                                          paddingLeft: "20px",
                                        }}
                                      >
                                        <div className="d-flex">
                                          {val?.site_name}
                                        </div>
                                      </div>
                                      <div className="col-2">
                                        {/*TOGGLE*/}
                                        <div className="dropdown dropdown-data show">
                                          <span
                                            className=""
                                            href="#"
                                            role="button"
                                            id="dropdownMenuLink"
                                            data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                          >
                                            <i className="fas fa-bars"></i>
                                          </span>
                                          <div
                                            className="dropdown-menu show-dpd"
                                            aria-labelledby="dropdownMenuLink"
                                          >
                                            <a
                                              className="dropdown-item"
                                              href={`inspect-lead/${val?.id}`}
                                            >
                                              <i className="fas fa-eye"></i>{" "}
                                              View
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                         
                                    <div className="row list-view">
                                      {val?.city_name !== null && (
                                        <div className="mb-flex">
                                          <div className="col-md-6 col-sm-6 no-wrap">
                                            <i className="fas fa-paint-brush"></i>
                                            &nbsp;&nbsp;City:
                                          </div>
                                          <div className="col-md-6 col-sm-6">
                                            {val?.city_name}
                                          </div>
                                        </div>
                                      )}
                                      {val?.site_address !== null &&(
                                          <div className="mb-flex">
                                            <div className="col-md-6 col-sm-6 no-wrap">
                                              <i className="fas fa-map-marker"></i>
                                              &nbsp;&nbsp;Addesss:
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                              {val?.site_address}
                                            </div>
                                          </div>
                                        )}

                                      <div className="mb-flex">
                                        <div className="col-md-6 col-sm-6 no-wrap">
                                          <i className="fas fa-user-tie"></i>
                                          &nbsp;&nbsp;Assigned To:
                                        </div>
                                        <div className="col-md-6 col-sm-6">
                                          <span
                                            className="trigger"
                                            data-tooltip-id="1"
                                            title={val?.name||'N/A'}
                                          >
                                            {val?.name||'N/A'}
                                          </span>
                                        </div>
                                      </div>

                                      {val?.last_activity_on_account !== null &&
                                      val?.last_activity_on_account !==
                                        undefined ? (
                                        <div className="mb-flex">
                                          <div className="col-md-6 col-sm-6 no-wrap">
                                            <i className="fas fa-calendar-alt"></i>
                                            &nbsp;&nbsp;Last action date
                                          </div>
                                          <div className="col-md-6 col-sm-6">
                                            <span
                                              className="trigger"
                                              data-tooltip-id="2"
                                              title={
                                                Moment(
                                                  val?.last_activity_on_account
                                                    ?.activity_date
                                                ).format("DD-MM-YYYY") +
                                                " ( " +
                                                val?.last_activity_on_account
                                                  ?.activity_type?.name +
                                                " )"
                                              }
                                            >
                                              {Moment(
                                                val?.last_activity_on_account
                                                  ?.activity_date
                                              ).format("DD-MM-YYYY") +
                                                " ( " +
                                                val?.last_activity_on_account
                                                  ?.activity_type?.name +
                                                " )"}
                                            </span>
                                          </div>
                                        </div>
                                      ) : val?.opportunities?.length > 0 ? (
                                        <>
                                          <div className="mb-flex">
                                            <div className="col-md-6 col-sm-6 no-wrap">
                                              <i className="fas fa-calendar-alt"></i>
                                              &nbsp;&nbsp;Last Action Date
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                              <span
                                                className="trigger"
                                                data-tooltip-id="3"
                                                title={
                                                  Moment(
                                                    val?.opportunities[
                                                      val?.opportunities
                                                        .length - 1
                                                    ]?.created_at
                                                  ).format("DD-MM-YYYY") +
                                                  " ( Opp. create )"
                                                }
                                              >
                                                {Moment(
                                                  val?.opportunities[
                                                    val?.opportunities.length -
                                                      1
                                                  ]?.created_at
                                                ).format("DD-MM-YYYY") +
                                                  " ( Opp. create )"}
                                              </span>
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        <div className="mb-flex">
                                          <div className="col-md-6 col-sm-6 no-wrap">
                                            <i className="fas fa-calendar-alt"></i>
                                            &nbsp;&nbsp;Last Action Date
                                          </div>
                                          <div className="col-md-6 col-sm-6">
                                            <span
                                              className="trigger"
                                              data-tooltip-id="3"
                                              title={
                                                Moment(val?.created_at).format(
                                                  "DD-MM-YYYY"
                                                ) + " ( Account created )"
                                              }
                                            >
                                              {Moment(val?.created_at).format(
                                                "DD-MM-YYYY"
                                              ) + " ( Account created )"}
                                            </span>
                                          </div>
                                        </div>
                                      )}
                                      {val?.next_activity_on_account !==
                                      null ? (
                                        <div className="mb-flex">
                                          <div className="col-md-6 col-sm-6 no-wrap">
                                            <i className="fas fa-calendar-alt calendar-gr"></i>
                                            &nbsp;&nbsp;Next action date
                                          </div>
                                          <div className="col-md-6 col-sm-6">
                                            <span
                                              className="trigger"
                                              data-tooltip-id="1"
                                              title={
                                                Moment(
                                                  val?.next_activity_on_account
                                                    ?.activity_date
                                                ).format("DD-MM-YYYY")
                                              }
                                            >
                                              {Moment(
                                                val?.next_activity_on_account
                                                  ?.activity_date
                                              ).format("DD-MM-YYYY")}
                                            </span>
                                          </div>
                                        </div>
                                      ) : (
                                        <div className="mb-flex">
                                          <div className="col-md-6 col-sm-6 no-wrap">
                                            <i className="fas fa-calendar-alt calendar-gr"></i>
                                            &nbsp;&nbsp;Next Action Date
                                          </div>
                                          <div className="col-md-6 col-sm-6">
                                            <span
                                              className="trigger"
                                              data-tooltip-id="1"
                                              title={
                                                val?.first_contact_date !== null
                                                  ? Moment(
                                                      val?.first_contact_date
                                                    ).format("DD-MM-YYYY") +
                                                    " ( first contract date )"
                                                  : null
                                              }
                                            >
                                              {val?.first_contact_date !== null
                                                ? Moment(
                                                    val?.first_contact_date
                                                  ).format("DD-MM-YYYY") +
                                                  " ( first contract date )"
                                                : null}
                                            </span>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                    <hr />
                                    <div
                                      className="row list-view-links"
                                      style={{ padding: "12px" }}
                                    >
                                      <ul>
                                        <li></li>
                                        {val?.last_activity_v2_on_account ===
                                          null &&
                                          val?.stage_name !== "Draft" && (
                                            <li style={{ margin: "-8px" }}>
                                              <a
                                                href={
                                                  match?.params?.lead_id !==
                                                  undefined
                                                    ? `/opportunity-list/${val?.id}/${match?.params?.lead_id}`
                                                    : `opportunity-list/${val?.id}`
                                                }
                                              >
                                                <i className="bi bi-list"></i>
                                                &nbsp;&nbsp;Opportunity
                                              </a>
                                            </li>
                                          )}
                                        {val?.last_activity_v2_on_account !==
                                          undefined &&
                                          val?.last_activity_v2_on_account !==
                                            null &&
                                          val?.last_activity_v2_on_account
                                            ?.id !== undefined && (
                                            <li style={{ margin: "-8px" }}>
                                              <a
                                                href={`last-meeting-history/${val?.last_activity_v2_on_account?.id}`}
                                              >
                                                <i className="bi bi-list"></i>
                                                &nbsp;&nbsp;Last meeting
                                              </a>
                                            </li>
                                          )}
                                        {/*<li><a*/}
                                        {/*    href={`account-activity-list/${val?.id}`}><i*/}
                                        {/*    className="bi bi-alarm"></i>&nbsp;&nbsp;Activity</a>*/}
                                        {/*</li>*/}
                                      </ul>
                                    </div>
                                  </h6>
                                  
                                  {/* {(parseInt(roleId) === 5 ||
                                    parseInt(roleId) === 6 ||
                                    parseInt(roleId) === 7 ||
                                    parseInt(roleId) === 16 ||
                                    parseInt(roleId) === 4) && (
                                    <div className="col-sm-6">
                                      <a
                                        href={`inspect-lead/${match?.params?.id}`}
                                        className="draft-float"
                                      >
                                        <p
                                          className="my-float"
                                          style={{ marginTop: "20px" }}
                                        >
                                          <i
                                            className="fa fa-plus"
                                            aria-hidden="true"
                                          ></i>
                                        </p>
                                      </a>
                                    </div>
                                  )} */}
                                  {parseInt(checkForThreeMonth) >= 3 &&
                                    <div className="col-sm-6" key={i}>
                                      <a
                                          href={`inspect-lead/${match?.params?.id}`}
                                          className="draft-float"
                                      >
                                        <p className="my-float" style={{ marginTop: "20px" }}>
                                          <i className="fa fa-plus" aria-hidden="true"></i>
                                        </p>
                                      </a>
                                    </div>
                                  }

                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })}

                  {inspectionList &&
                    inspectionList?.data !== undefined &&
                    inspectionList?.data.length > 0 && (
                      <div className="panel-pagination-col panel-table-pagination">
                        <ReactPaginate
                          previousLabel={"<"}
                          nextLabel={">"}
                          breakLabel={"..."}
                          breakClassName={"break-me"}
                          pageCount={inspectionList?.total / inspectionList?.per_page}
                          forcePage={inspectionList?.current_page - 1}
                          pageRangeDisplayed={4}
                          onPageChange={onPageChange}
                          activeClassName={"active"}
                        />
                      </div>
                    )}

                  {inspectionList &&
                    inspectionList?.data !== undefined &&
                    inspectionList?.data?.length === 0 && (
                      <>
                        <img src={NotFoundData} className="not-found-data" />
                        <div className="text-center" style={{ width: "100%" }}>
                          Data Not Found
                        </div>
                        {/* {(parseInt(roleId) === 5 ||
                          parseInt(roleId) === 6 ||
                          parseInt(roleId) === 7 ||
                          parseInt(roleId) === 16 ||
                          parseInt(roleId) === 4) && (
                          <div className="col-sm-6">
                            <a
                              href={`inspect-lead/${match?.params?.id}`}
                              className="draft-float"
                            >
                              <p
                                className="my-float"
                                style={{ marginTop: "20px" }}
                              >
                                <i
                                  className="fa fa-plus"
                                  aria-hidden="true"
                                ></i>
                              </p>
                            </a>
                          </div>
                        )} */}
                        {/* {inspectionList && inspectionList?.data.length === 0 && */}
                            <div className="col-sm-6">
                              <a
                                  href={`inspect-lead/${match?.params?.id}`}
                                  className="draft-float"
                              >
                                <p className="my-float" style={{ marginTop: "20px" }}>
                                  <i className="fa fa-plus" aria-hidden="true"></i>
                                </p>
                              </a>
                            </div>
                        {/* } */}

                      </>
                    )}
                  {/*PAGINATION END*/}
                  <div className="col-sm-6">
                              <a
                                  href={`inspect-lead-create/${match?.params?.id}`}
                                  className="draft-float"
                              >
                                <p className="my-float" style={{ marginTop: "20px" }}>
                                  <i className="fa fa-plus" aria-hidden="true"></i>
                                </p>
                              </a>
                            </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <BottomMenu
          open={open}
          setOpen={setOpen}
          filterContent={accountFilterContent}
          handleFilter={handleFilter}
          handleSubmitFilter={handleSubmitFilter}
          requiredDataOnChange={requiredDataOnChange}
          setIsRemoveFilter={setIsRemoveFilter}
        />
      </div>
      {/* section ends */}
    </>
  );
};

export default InspectionList;
